import { httpClient } from 'utils/httpClient';
import { apiErrorHandler } from 'utils/apis/helpers';

const base = '/marketplace/owner-reporting';

const withHost = (params, hostId) => ({ ...(params || {}), hostId });

export const listServicePackages = (hostId, params = {}) =>
  httpClient
    .get(`${base}/service-packages`, { params: withHost(params, hostId) })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const createServicePackage = (hostId, body) =>
  httpClient
    .post(`${base}/service-packages`, { ...body, hostId })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const updateServicePackage = (hostId, id, body) =>
  httpClient
    .patch(`${base}/service-packages/${id}`, { ...body, hostId })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const deleteServicePackage = (hostId, id) =>
  httpClient
    .delete(`${base}/service-packages/${id}`, { params: { hostId } })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const listV1ServicePackages = hostId =>
  httpClient
    .get(`${base}/service-packages/from-v1`, { params: { hostId } })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const getV1ServicePackagePreview = (hostId, id) =>
  httpClient
    .get(`${base}/service-packages/from-v1/${id}`, { params: { hostId } })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const listRevenue = (hostId, params = {}) =>
  httpClient
    .get(`${base}/revenue`, { params: withHost(params, hostId) })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const upsertRevenue = (hostId, body) =>
  httpClient
    .post(`${base}/revenue/upsert`, { ...body, hostId })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const autoCalculateRevenue = (hostId, body) =>
  httpClient
    .post(`${base}/revenue/auto-calculate`, { ...body, hostId })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const updateBookingCleaningFee = (hostId, body) =>
  httpClient
    .patch(`${base}/revenue/booking-cleaning-fee`, { ...body, hostId })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const listExpenses = (hostId, params = {}) =>
  httpClient
    .get(`${base}/expenses`, { params: withHost(params, hostId) })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const upsertExpenses = (hostId, body) =>
  httpClient
    .post(`${base}/expenses/upsert`, { ...body, hostId })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const bulkUpsertExpenses = (hostId, body) =>
  httpClient
    .post(`${base}/expenses/bulk-upsert`, { ...body, hostId })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const listInstallments = (hostId, params = {}) =>
  httpClient
    .get(`${base}/installments`, { params: withHost(params, hostId) })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const createInstallment = (hostId, body) =>
  httpClient
    .post(`${base}/installments`, { ...body, hostId })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const deleteInstallment = (hostId, id) =>
  httpClient
    .delete(`${base}/installments/${id}`, { params: { hostId } })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const listCalendarInventory = (hostId, params = {}) =>
  httpClient
    .get(`${base}/calendar/inventory`, { params: withHost(params, hostId) })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const listOwnerUnits = (hostId, params = {}) =>
  httpClient
    .get(`${base}/units`, { params: withHost(params, hostId) })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const getDashboardSummary = (hostId, params = {}) =>
  httpClient
    .get(`${base}/dashboard/summary`, { params: withHost(params, hostId) })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const listReports = (hostId, params = {}) =>
  httpClient
    .get(`${base}/reporting`, { params: withHost(params, hostId) })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const getReportingInfo = (hostId, params) =>
  httpClient
    .get(`${base}/reporting/info`, { params: withHost(params, hostId) })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const upsertReporting = (hostId, body) =>
  httpClient
    .post(`${base}/reporting/upsert`, { ...body, hostId })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const autoCalculateReporting = (hostId, body) =>
  httpClient
    .post(`${base}/reporting/auto-calculate`, { ...body, hostId })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const auditReporting = (hostId, body) =>
  httpClient
    .patch(`${base}/reporting/audit`, { ...body, hostId })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const unauditReporting = (hostId, body) =>
  httpClient
    .post(`${base}/reporting/unaudit`, { ...body, hostId })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const previewBulkAudit = (hostId, body) =>
  httpClient
    .post(`${base}/reporting/bulk-audit/preview`, { ...body, hostId })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const bulkAuditReports = (hostId, body) =>
  httpClient
    .post(`${base}/reporting/bulk-audit`, { ...body, hostId })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const previewBulkPaid = (hostId, body) =>
  httpClient
    .post(`${base}/reporting/bulk-paid/preview`, { ...body, hostId })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const bulkPaidReports = (hostId, body) =>
  httpClient
    .post(`${base}/reporting/bulk-paid`, { ...body, hostId })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const setPaymentStatus = (hostId, body) =>
  httpClient
    .post(`${base}/reporting/payment-status`, { ...body, hostId })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const getAuditedReportsByOwner = (hostId, params = {}) =>
  httpClient
    .get(`${base}/reporting/audited-report`, { params: withHost(params, hostId) })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const exportAuditedReports = (hostId, body) =>
  httpClient
    .post(`${base}/reporting/export-audited`, { ...body, hostId })
    .then(r => r.data)
    .catch(apiErrorHandler);

const base64ToPdfBlob = pdfBuffer => {
  const binary = atob(pdfBuffer);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new Blob([bytes], { type: 'application/pdf' });
};

/**
 * Returns { blob, filename } for an owner-reporting statement PDF.
 */
export const getReportPdf = (hostId, params) =>
  httpClient
    .get(`${base}/reporting/pdf`, { params: withHost(params, hostId) })
    .then(r => {
      const data = r.data || {};
      if (!data.pdfBuffer) {
        throw new Error((data && data.error) || 'PDF buffer missing');
      }
      return {
        blob: base64ToPdfBlob(data.pdfBuffer),
        filename: data.filename || 'owner-report.pdf',
      };
    })
    .catch(apiErrorHandler);


export const getUnitSettings = (hostId, unitId) =>
  httpClient
    .get(`${base}/unit-settings/${unitId}`, { params: { hostId } })
    .then(r => r.data)
    .catch(apiErrorHandler);

export const upsertUnitSettings = (hostId, unitId, body) =>
  httpClient
    .put(`${base}/unit-settings/${unitId}`, { ...body, hostId })
    .then(r => r.data)
    .catch(apiErrorHandler);
